import React from 'react';
import { MoonIcon } from 'lucide-react';
import { ScrollFadeIn } from './ScrollFadeIn';
export function Hero() {
  const scrollToCTA = () => {
    document.getElementById('final-cta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-slate-900 pt-20 pb-16 px-4 sm:px-6 lg:px-8" data-id="element-530">
      {/* Atmospheric background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-531">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-amber-500/5 rounded-full blur-3xl" data-id="element-532" />
        <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-slate-900 to-transparent" data-id="element-533" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-534">
        <ScrollFadeIn delay={0.1} data-id="element-535">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-slate-800/50 border border-slate-700/50 text-amber-500 text-sm font-medium mb-8" data-id="element-536">
            <MoonIcon className="w-4 h-4" data-id="element-537" />
            <span data-id="element-538">For Stressed Professionals 40+</span>
          </div>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.2} data-id="element-539">
          <h1 className="text-5xl md:text-7xl font-bold text-slate-50 mb-6 leading-tight" data-id="element-540">
            The Cortisol{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600 italic" data-id="element-541">
              Switch
            </span>
          </h1>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.3} data-id="element-542">
          <p className="text-xl md:text-2xl text-slate-300 mb-10 max-w-3xl mx-auto leading-relaxed font-light" data-id="element-543">
            Stop the "Tired but Wired" Cycle, Master Your Vagus Nerve, and
            Finally Melt Stubborn Stress-Fat After 40.
          </p>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.4} data-id="element-544">
          <button onClick={scrollToCTA} className="cta-pulse inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-slate-900 bg-amber-500 rounded-lg hover:bg-amber-400 transition-colors duration-300" data-id="element-545">
            Get The Manual Now
          </button>
          <p className="mt-4 text-sm text-slate-400" data-id="element-546">
            Immediate Digital Access • Secure Checkout
          </p>
        </ScrollFadeIn>
      </div>
    </section>;
}